import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ErrorBoundary from "@/components/ErrorBoundary";
import ScrollManager from "@/components/ScrollManager";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AccountPending from "@/pages/AccountPending";
import Regulation from "@/pages/Regulation";
import Squadre from "@/pages/Squadre";
import PresidenteDashboard from "@/pages/PresidenteDashboard";
import Antidoping from "@/pages/Antidoping";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminDivisions from "@/pages/admin/AdminDivisions";
import AdminCalendario from "@/pages/admin/AdminCalendario";
import AdminTeams from "@/pages/admin/AdminTeams";
import AdminRegulation from "@/pages/admin/AdminRegulation";
import AdminPesdbSync from "@/pages/admin/AdminPesdbSync";
import AdminPesdbLink from "@/pages/admin/AdminPesdbLink";
import AdminPesdbRelink from "@/pages/admin/AdminPesdbRelink";
import AdminPesdbAudit from "@/pages/admin/AdminPesdbAudit";
import AdminUpdateRequests from "@/pages/admin/AdminUpdateRequests";
import AdminCounterpartyAudit from "@/pages/admin/AdminCounterpartyAudit";import AdminBudgetReconciliation from "@/pages/admin/AdminBudgetReconciliation";import AdminPrizesImport from "@/pages/admin/AdminPrizesImport";
import AdminTmAge from "@/pages/admin/AdminTmAge";
import AdminFeaturedLinks from "@/pages/admin/AdminFeaturedLinks";
import AdminLegacyImport from "@/pages/admin/AdminLegacyImport";
import Players from "@/pages/Players";
import PlayerDetail from "@/pages/PlayerDetail";
import TeamDetail from "@/pages/TeamDetail";
import Bilancio from "@/pages/Bilancio";
import Mercato from "@/pages/Mercato";
import Campionati from "@/pages/Campionati";
import CampionatoDetail from "@/pages/CampionatoDetail";
import Coppe from "@/pages/Coppe";
import Calendario from "@/pages/Calendario";
import CoppaDetail from "@/pages/CoppaDetail";
import AdminMercato from "@/pages/admin/AdminMercato";
import AdminStatisticheMercato from "@/pages/admin/AdminStatisticheMercato";
import AdminDoppioniAste from "@/pages/admin/AdminDoppioniAste";
import AdminSvincolati from "@/pages/admin/AdminSvincolati";
import AdminInjuries from "@/pages/admin/AdminInjuries";
import AdminAssenze from "@/pages/admin/AdminAssenze";
import AdminBots from "@/pages/admin/AdminBots";
import AdminObblighi from "@/pages/admin/AdminObblighi";
import AdminWageParams from "@/pages/admin/AdminWageParams";
import AdminStadi from "@/pages/admin/AdminStadi";
import AdminPrimavera from "@/pages/admin/AdminPrimavera";
import AdminDbMigration from "@/pages/admin/AdminDbMigration";
import AdminTelegram from "@/pages/admin/AdminTelegram";
import AdminAnnouncements from "@/pages/admin/AdminAnnouncements";
import AdminTavolini from "@/pages/admin/AdminTavolini";
import AdminDisciplinare from "@/pages/admin/AdminDisciplinare";
import Albo from "@/pages/Albo";
import Ranking from "@/pages/Ranking";
import AlboPremi from "@/pages/AlboPremi";
import Disciplinare from "@/pages/Disciplinare";

function App() {
    return (
        <div className="App op-noise">
            <BrowserRouter>
                <AuthProvider>
                    <FavoritesProvider>
                    <Header />
                    <RoutedContent />
                    <Footer />
                    </FavoritesProvider>
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

function RoutedContent() {
    const location = useLocation();
    return (
        <ErrorBoundary resetKey={location.pathname}>
            <ScrollManager />
                    <Routes>
                        {/* PUBBLICHE: solo accesso e iscrizione */}
                        <Route path="/login" element={<Login />} />
                        <Route path="/signup" element={<Signup />} />
                        <Route path="/account-pending" element={<AccountPending />} />

                        {/* PROTETTE: tutto il resto del sito è visibile solo a utenti approvati */}
                        <Route element={<ProtectedRoute />}>
                            <Route path="/" element={<Landing />} />
                            <Route path="/squadre" element={<Squadre />} />
                            <Route path="/squadre/:teamId" element={<TeamDetail />} />
                            <Route path="/bilancio" element={<Bilancio />} />
                            <Route path="/mercato" element={<Mercato />} />
                            <Route path="/campionati" element={<Campionati />} />
                            <Route path="/campionati/:divisionCode" element={<CampionatoDetail />} />
                            <Route path="/coppe" element={<Coppe />} />
                            <Route path="/coppe/:slug" element={<CoppaDetail />} />
                            <Route path="/calendario" element={<Calendario />} />
                            <Route path="/antidoping" element={<Antidoping />} />
                            <Route path="/albo" element={<Albo />} />
                            <Route path="/ranking" element={<Ranking />} />
                            <Route path="/albo-premi" element={<AlboPremi />} />
                            <Route path="/disciplinare" element={<Disciplinare />} />
                            <Route path="/giocatori" element={<Players />} />
                            <Route path="/giocatori/:pesId" element={<PlayerDetail />} />
                            <Route path="/regolamento" element={<Regulation />} />
                            <Route path="/presidente" element={<PresidenteDashboard />} />

                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute requireRole="admin">
                                        <AdminLayout />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<AdminOverview />} />
                                <Route path="users" element={<AdminUsers />} />
                                <Route path="divisions" element={<AdminDivisions />} />
                                <Route path="calendario" element={<AdminCalendario />} />
                                <Route path="tavolini" element={<AdminTavolini />} />
                                <Route path="disciplinare" element={<AdminDisciplinare />} />
                                <Route path="assenze" element={<AdminAssenze />} />
                                <Route path="teams" element={<AdminTeams />} />
                                <Route path="mercato" element={<AdminMercato />} />
                                <Route path="statistiche-mercato" element={<AdminStatisticheMercato />} />
                                <Route path="doppioni-aste" element={<AdminDoppioniAste />} />
                                <Route path="svincolati" element={<AdminSvincolati />} />
                                <Route path="injuries" element={<AdminInjuries />} />
                                <Route path="cina" element={<AdminBots />} />
                                <Route path="obblighi" element={<AdminObblighi />} />
                                <Route path="wages" element={<AdminWageParams />} />
                                <Route path="stadi" element={<AdminStadi />} />
                                <Route path="primavera" element={<AdminPrimavera />} />
                                <Route path="db-migration" element={<AdminDbMigration />} />
                                <Route path="annunci" element={<AdminAnnouncements />} />
                                <Route path="telegram" element={<AdminTelegram />} />
                                <Route path="regulation" element={<AdminRegulation />} />
                                <Route path="pesdb" element={<AdminPesdbSync />} />
                                <Route path="pesdb-link" element={<AdminPesdbLink />} />
                                <Route path="pesdb-relink" element={<AdminPesdbRelink />} />
                                <Route path="pesdb-audit" element={<AdminPesdbAudit />} />
                                <Route path="update-requests" element={<AdminUpdateRequests />} />
                                <Route path="counterparty-audit" element={<AdminCounterpartyAudit />} />
                                <Route path="budget-reconciliation" element={<AdminBudgetReconciliation />} />
                                <Route path="prizes-import" element={<AdminPrizesImport />} />
                                <Route path="tm-age" element={<AdminTmAge />} />
                                <Route path="featured-links" element={<AdminFeaturedLinks />} />
                                <Route path="legacy" element={<AdminLegacyImport />} />
                            </Route>
                        </Route>
                    </Routes>
        </ErrorBoundary>
    );
}

export default App;
